import { useMemo } from 'react';
import { useGetSitesPermissionsQuery } from '@features/sites/sitesAPI';
import { useMaintenanceInfo } from '@features/admin/adminAPI';

export default function useAppInitRequests() {
  const { data: _sitesPermissions, isLoading: isLoadingSitesPermissions } =
    useGetSitesPermissionsQuery();
  const { data: _maintenanceInfo, isLoading: isLoadingMaintenanceInfo } =
    useMaintenanceInfo();
  const isLoading = useMemo(() => {
    return isLoadingSitesPermissions || isLoadingMaintenanceInfo;
  }, [isLoadingSitesPermissions, isLoadingMaintenanceInfo]);

  return { isLoading };
}
